<template>
  <div :class="classes">
    <input
      :value="value"
      :disabled="disabled"
      :placeholder="placeholder"
      :type="type"
      @input="$emit('input', $refs.input.value)"
      ref="input"
    />
    <span @click="passwordToggle" v-if="isPassword" class="password"></span>
  </div>
</template>
<script>
export default {
  name: "bx-input",
  props: {
    value: {
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    error: {
      type: Boolean,
      default: false
    },
    success: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "text"
    }
  },
  data() {
    return {
      isPassword: false,
      passwordShow: false
    };
  },
  computed: {
    classes() {
      const classes = ["bx-input"];

      if (this.error) {
        classes.push("bx-input-error");
      }

      if (this.success) {
        classes.push("bx-input-success");
      }

      if (this.isPassword) {
        classes.push("bx-input-password");
      }

      if (this.passwordShow) {
        classes.push("bx-input-password-reveled");
      }

      return classes;
    }
  },
  methods: {
    passwordToggle() {
      this.type = this.type === "password" ? "text" : "password";
      this.passwordShow = !(this.type === "password");
    }
  },
  mounted() {
    if (this.type === "password") {
      this.isPassword = true;
    }
  }
};
</script>
